// Utility to measure time between two points
export const measureTimeBetween = (startTime: number): number =>
  Math.round(performance.now() - startTime);

// Start measuring event time
export const startMeasurement = (): number => performance.now();
